// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file requests/v1/package_provider_feature_request.proto (package requests.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file requests/v1/package_provider_feature_request.proto.
 */
export const file_requests_v1_package_provider_feature_request: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjJyZXF1ZXN0cy92MS9wYWNrYWdlX3Byb3ZpZGVyX2ZlYXR1cmVfcmVxdWVzdC5wcm90bxILcmVxdWVzdHMudjEimQEKHVBhY2thZ2VQcm92aWRlckZlYXR1cmVSZXF1ZXN0EhoKCHByb3ZpZGVyGAEgASgJQgi6SAVyAxj/ARIiCgtkZXNjcmlwdGlvbhgCIAEoCUIIukgFcgMYgARIAIgBARIUCgxjb3VudHJ5X2NvZGUYAyABKAkSEgoKaGFzX2FjY2VzcxgEIAEoCEIOCgxfZGVzY3JpcHRpb25CiAEKD2NvbS5yZXF1ZXN0cy52MUIiUGFja2FnZVByb3ZpZGVyRmVhdHVyZVJlcXVlc3RQcm90b1ABWgQuL3BiogIDUlhYqgILUmVxdWVzdHMuVjHKAgtSZXF1ZXN0c1xWMeICF1JlcXVlc3RzXFYxXEdQQk1ldGFkYXRh6gIMUmVxdWVzdHM6OlYxYgZwcm90bzM',
        [file_buf_validate_validate]
    );

/**
 * @generated from message requests.v1.PackageProviderFeatureRequest
 */
export type PackageProviderFeatureRequest = Message<'requests.v1.PackageProviderFeatureRequest'> & {
    /**
     * @generated from field: string provider = 1;
     */
    provider: string;

    /**
     * @generated from field: optional string description = 2;
     */
    description?: string | undefined;

    /**
     * @generated from field: string country_code = 3;
     */
    countryCode: string;

    /**
     * @generated from field: bool has_access = 4;
     */
    hasAccess: boolean;
};

/**
 * Describes the message requests.v1.PackageProviderFeatureRequest.
 * Use `create(PackageProviderFeatureRequestSchema)` to create a new message.
 */
export const PackageProviderFeatureRequestSchema: GenMessage<PackageProviderFeatureRequest> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_package_provider_feature_request, 0);
